/**
 * 修正 referrer 问题（APP不支持 document.referrer）
 * 注意：本函数必须在所有需要用到 sa_referrer 前执行
 */
import * as cookie from './cookie';
import { isHostApp } from './ua';
import * as utilObject from './object';
import { onPageShow } from '../native/page-show-event';


function fixReferrer() {
  if (fixReferrer.executed) return;
  fixReferrer.executed = true;
  // 存在当前页面“进程”的内存
  // 当前页面的 document.referrer == sa_referrer
  fixReferrer.sa_referrer = cookie.get('sa_referrer');
  // 传递给下一页的 referrer
  cookie.set('sa_referrer', utilObject.get(window, 'location.href'));
}
// 执行
fixReferrer();


// 修正app返回操作
onPageShow(() => {
  // 修正传递给下一页的 referrer
  cookie.set('sa_referrer', utilObject.get(window, 'location.href'));
});

// 获取修正后的 referrer
export function getReferrer() {
  let result = document.referrer;
  // APP内 result 肯定是 空字符串
  if (!result && isHostApp()) {
    result = fixReferrer.sa_referrer;
  }

  return result;
}
